module.exports = __webpack_public_path__ + "static/media/JMK01@s.ad8971bc.jpg";